import { withFormik } from "formik";
import { connect } from "react-redux";
import { loginUser } from "../../../slices/authSlice";
import LoginForm from "./LoginForm";
import * as Yup from "yup";

//constants
import {
  PASSWORD_REQUIRED,
  PASSWORD_SHORT_ERROR,
} from "../../../constants/messages/formMessages";

const EnhancedLoginForm = withFormik({
  mapPropsToValues: () => ({
    text: "",
    password: "",
  }),
  validationSchema: Yup.object().shape({
    text: Yup.string().required("Email or username required!"),

    password: Yup.string()
      .required(PASSWORD_REQUIRED)
      .min(6, PASSWORD_SHORT_ERROR),
  }),
  handleSubmit: (values, { setSubmitting, props }) => {
    const { loginUser } = props;

    if (values.text.endsWith(".com")) {
      const formData = {
        email: values.text,
        password: values.password,
      };
      loginUser(formData);
    } else {
      const formData = {
        username: values.text,
        password: values.password,
      };
      loginUser(formData);
    }
    console.log(values);
    setSubmitting(false);
  },
  displayName: "LoginForm",
})(LoginForm);

export default connect(null, { loginUser })(EnhancedLoginForm);
